/** Deterministic RNG (mulberry32). Every system MUST use this, never Math.random. */
export class RNG {
  constructor(seed = 1337) { this.seed(seed); }
  seed(s) { this._s = (s >>> 0) || 1; return this; }
  next() {
    let t = (this._s += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  range(a, b) { return a + (b - a) * this.next(); }
  int(a, b) { return Math.floor(this.range(a, b + 1)); }
  pick(arr) { return arr[Math.floor(this.next() * arr.length)]; }
  sign() { return this.next() < 0.5 ? -1 : 1; }
  /** Gaussian-ish via sum of 3 uniforms, mean 0, ~unit sd. */
  gauss() { return (this.next() + this.next() + this.next() - 1.5) * 1.1547; }
  /** Uniform point in unit disc. */
  disc(out) { const a = this.next() * Math.PI * 2, r = Math.sqrt(this.next()); out.x = Math.cos(a) * r; out.y = Math.sin(a) * r; return out; }
  fork(salt = 0) { return new RNG((this._s ^ Math.imul(salt + 1, 0x9e3779b9)) >>> 0); }
}
export const rng = new RNG(20240819);
